// @flow
import * as React from 'react';
import { Base, MainIcon, Popup, ShadowMask } from './styles';
import generalIcons from '~/core/constants/icons/general-svg';
import keys from '~/core/constants/key-codes';
import PopupItem from './popup-item';

type Props = {
    children?: Array<React.Element<typeof PopupItem>> | React.Element<typeof PopupItem>,
    left?: boolean
};

type State = {
    selected: boolean,
    selectedItem: ?number
};

export default class ContextMenu extends React.Component<Props, State> {
    static Item = PopupItem;
    state = {
        selected: false,
        selectedItem: null
    };

    show = (e: Event | SyntheticKeyboardEvent<>) => {
        e.stopPropagation();

        if (!this.state.selected) {
            this.setState({ selected: true, selectedItem: null });
        }
    };

    close = (e: Event | SyntheticKeyboardEvent<>) => {
        e.stopPropagation();

        if (this.state.selected) {
            this.setState({ selected: false });
        }
    };

    keyDown = (e: SyntheticKeyboardEvent<>) => {
        const switchCase: { [number]: () => void } = {
            [keys.SPACE]: () => {
                e.preventDefault();
                this.show(e);
            },
            [keys.ARROW_UP]: () => {
                e.preventDefault();
                const { selectedItem } = this.state;
                if (selectedItem === null) {
                    this.setState({ selectedItem: 0 });
                } else if (typeof selectedItem === 'number' && selectedItem > 0) {
                    this.setState({ selectedItem: selectedItem - 1 });
                }
            },
            [keys.ARROW_DOWN]: () => {
                e.preventDefault();
                const { selectedItem } = this.state;
                if (selectedItem === null) {
                    this.setState({ selectedItem: 0 });
                } else if (
                    typeof selectedItem === 'number' &&
                    selectedItem < React.Children.count(this.props.children) - 1
                ) {
                    this.setState({ selectedItem: selectedItem + 1 });
                }
            },
            [keys.ESCAPE]: () => {
                this.close(e);
            },
            [keys.ENTER]: () => {
                const { selectedItem } = this.state;
                if (typeof selectedItem === 'number') {
                    this.triggerAction(React.Children.toArray(this.props.children)[selectedItem].props.action);
                }
            }
        };

        if (typeof switchCase[e.keyCode] === 'function') {
            switchCase[e.keyCode]();
        }
    };

    triggerAction = (action: () => void) => {
        this.setState({ selected: false });
        action();
    };

    render() {
        const { children, left } = this.props;
        const { selected, selectedItem } = this.state;

        if (!children) {
            return <Base />;
        }

        const childrenWithProps = React.Children.map(children, (child, index) =>
            React.cloneElement(child, {
                index,
                action: e => {
                    e.stopPropagation();
                    this.triggerAction(child.props.action);
                },
                selected: selectedItem === index
            })
        );

        return (
            <Base onBlur={this.close} onKeyDown={this.keyDown} selected={selected} tabIndex="0">
                <div onClick={selected ? this.close : this.show}>
                    <MainIcon selected={selected} type={generalIcons.MORE} />
                </div>
                {selected && [
                    <Popup key="popup" left={left} selected={selected}>
                        {childrenWithProps}
                    </Popup>,
                    <ShadowMask key="mask" />
                ]}
            </Base>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/context-menu/index.js